import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { H6, Image, P } from "../../../../AbstractElements";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";
import { dynamicImage } from "../../../../Utils";
import { JustifyTabData } from "../../../../Data/UiKits/Tabs";

const JustifyTabContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {JustifyTabData &&
        JustifyTabData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            <div className="designer-details">
              {item.data &&
                item.data.map((item, index) => (
                  <div className="designer-profile" key={index}>
                    <div className="designer-wrap">
                      <Image className="designer-img" src={dynamicImage(item.image)} alt="profile" />
                      <div className="designer-content">
                        <H6>{item.head}</H6>
                        <P>{item.text}</P>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </TabPane>
        ))}
    </TabContent>
  );
};

export default JustifyTabContent;
